import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export const fetchQuotationLog = createAsyncThunk(
  "quotation/fetchQuotationLog",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    console.log(filters)

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null) return;

          if (filterField === "quotation_date") {
            params.append(`${filterField}_from`, filterValue.from_date);
            params.append(`${filterField}_to`, filterValue.to_date);
          }
          else if (filterField === "validity") {
            params.append(`${filterField}_from`, filterValue.from_date);
            params.append(`${filterField}_to`, filterValue.to_date);
          } 
          else if (filterField === "follow_up_date") {
            params.append(`follow_up_date_from`, filterValue.from_date);
            params.append(`follow_up_date_to`, filterValue.to_date);
          } 
          else if (filterField === "next_follow_up_date") {
            params.append(`next_follow_up_date_from`, filterValue.from_date);
            params.append(`next_follow_up_date_to`, filterValue.to_date);
          } else

            // If filterValue is an object (like from_date/to_date)
            if (typeof filterValue === "object" && filterValue !== null) {
              if (filterValue.from_date)
                params.append(`${filterField}_date_from`, filterValue.from_date);
              if (filterValue.to_date)
                params.append(`${filterField}_date_to`, filterValue.to_date);
              // if (filterValue.quotation_to_date)
              //   params.append(`${filterField}_from`, filterValue.from_date);
              // if (filterValue.quotation_to_date)
              //   params.append(`${filterField}_to`, filterValue.to_date);


            } else {
              // Primitive value
              params.append(filterField, String(filterValue));
            }
        }
      );
    }

    const response: any = await Axios.get(
      `/api/quotation/list/?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);


export const fetchQuotationTrash = createAsyncThunk(
  "quotation/fetchQuotationTrash",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null) return;

          if (filterField === "quotation_date") {
            params.append(`${filterField}_from`, filterValue.from_date);
            params.append(`${filterField}_to`, filterValue.to_date);
          }
          else if (filterField === "validity") {
            params.append(`${filterField}_from`, filterValue.from_date);
            params.append(`${filterField}_to`, filterValue.to_date);
          } else

            // If filterValue is an object (like from_date/to_date)
            if (typeof filterValue === "object" && filterValue !== null) {
              if (filterValue.from_date)
                params.append(`${filterField}_date_from`, filterValue.from_date);
              if (filterValue.to_date)
                params.append(`${filterField}_date_to`, filterValue.to_date);
              // if (filterValue.quotation_to_date)
              //   params.append(`${filterField}_from`, filterValue.from_date);
              // if (filterValue.quotation_to_date)
              //   params.append(`${filterField}_to`, filterValue.to_date);


            } else {
              // Primitive value
              params.append(filterField, String(filterValue));
            }
        }
      );
    }

    const response: any = await Axios.get(
      `/api/quotation/trash/list/?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchQuotationById = createAsyncThunk(
  "quotation/fetchQuotationById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/api/quotation/view-details/${id}/`);
      console.log(response)
      return response?.data?.data ?? response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Quotation by ID");
    }
  }
);

export const fetchTrashQuotationById = createAsyncThunk(
  "quotation/fetchTrashQuotationById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/api/quotation/trash/view-details/${id}/`);
      // console.log(response)
      return response?.data?.data ?? response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Trash Quotation by ID");
    }
  }
);


export const deleteQuotationById = createAsyncThunk(
  "quotation/deleteQuotationById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.delete(`/api/quotation/delete/${id}/`);
      if (response?.data?.success) {
        return response.data.data; // return the deleted item
      }
      return rejectWithValue("Failed to delete Quotation");
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to delete Quotation");
    }
  }
);



export const revertQuotationById = createAsyncThunk(
  "quotation/revertQuotationById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`/api/quotation/trash/quotation-revert/${id}/`);
      if (response?.data?.success) {
        // return { id }; // return the Reverted item's id
        return response.data.data; // return the Reverted item
      }
      return rejectWithValue("Failed to Revert Quotation");
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to Revert Quotation");
    }
  }
)


export const changeQuotationStatusById = createAsyncThunk(
  "quotation/changeQuotationStatusById",
  async (
    { id, payload }: { id: string; payload: any },
    { rejectWithValue }
  ) => {
    // Handle both string (status) and object (follow_up_type or other fields) payloads
    let payload2: any;
    if (typeof payload === "string") {
      // For status updates, payload is a string
      payload2 = { current_status: payload };
    } else if (typeof payload === "object" && payload !== null) {
      // For other updates like follow_up_type, payload is already an object
      payload2 = payload;
    } else {
      payload2 = { current_status: payload };
    }
    
    try {
      const response: any = await Axios.patch(`/api/quotation/current-status-validity-update/${id}/`, payload2);
      if (response?.data?.data) {
        return response.data.data;
      }
      return rejectWithValue("Failed to change Quotation status");
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to change Quotation status");
    }
  }
);

export const addQuotation = createAsyncThunk(
  "quotation/addQuotation",
  async (formData: any, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("authUser") || "{}")?.access;

      const response = await Axios.post(`api/quotation/create/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      }
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add Quotation");
    }
  }
);


export const updateQuotation = createAsyncThunk(
  "quotation/updateQuotation",
  async ({ id, formData }: { id: string; formData: FormData }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("authUser") || "{}")?.access;

      const response = await Axios.put(`api/quotation/edit/${id}/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      }
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to Update Quotation");
    }
  }
);


export const downloadQuotationPDF = createAsyncThunk(
  "quotation/downloadQuotationPDF",
  async ({ id, signal }: { id: string; signal: AbortSignal }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/quotation/download-pdf/${id}/`, {
        responseType: "blob",
        signal, // 👈 attach AbortController signal
      });

      const contentType = response.headers["content-type"];
      if (contentType !== "application/pdf") {
        return rejectWithValue("Invalid file type received");
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `quotation_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { id, success: true };
    } catch (err: any) {
      if (err.name === "CanceledError" || err.name === "AbortError") {
        return rejectWithValue("Download cancelled by user.");
      }
      return rejectWithValue(err.response?.data || "Failed to download quotation PDF");
    }
  }
);



export const downloadQuotationPDF2 = createAsyncThunk(
  "quotation/downloadQuotationPDF2",
  async ({ id, signal }: { id: string; signal: AbortSignal }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/quotation/download-qty-pdf/${id}/`, {
        responseType: "blob",
        signal, // 👈 attach AbortController signal
      });

      const contentType = response.headers["content-type"];
      if (contentType !== "application/pdf") {
        return rejectWithValue("Invalid file type received");
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `quotation_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { id, success: true };
    } catch (err: any) {
      if (err.name === "CanceledError" || err.name === "AbortError") {
        return rejectWithValue("Download cancelled by user.");
      }
      return rejectWithValue(err.response?.data || "Failed to download quotation PDF");
    }
  }
);





//Exports csv file
export const exportQuotationCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null) return;

        if (filterField === "quotation_date") {
          params.append(`${filterField}_from`, filterValue.from_date);
          params.append(`${filterField}_to`, filterValue.to_date);
        }
        else if (filterField === "validity") {
          params.append(`${filterField}_from`, filterValue.from_date);
          params.append(`${filterField}_to`, filterValue.to_date);
        } else if (filterField === "follow_up_date") {
          params.append(`follow_up_date_from`, filterValue.from_date);
          params.append(`follow_up_date_to`, filterValue.to_date);
        } else if (filterField === "next_follow_up_date") {
          params.append(`next_follow_up_date_from`, filterValue.from_date);
          params.append(`next_follow_up_date_to`, filterValue.to_date);
        } else

          // If filterValue is an object (like from_date/to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            if (filterValue.from_date)
              params.append(`${filterField}_date_from`, filterValue.from_date);
            if (filterValue.to_date)
              params.append(`${filterField}_date_to`, filterValue.to_date);
            // if (filterValue.quotation_to_date)
            //   params.append(`${filterField}_from`, filterValue.from_date);
            // if (filterValue.quotation_to_date)
            //   params.append(`${filterField}_to`, filterValue.to_date);


          } else {
            // Primitive value
            params.append(filterField, String(filterValue));
          }
      }
    );
  }
  // Step 1: First call – get the file_url
  const response = await Axios.get(`/api/quotation/export-to-excel/?${params.toString()}`);

  const fileUrl = response.data?.file_url;
  if (!fileUrl) {
    throw new Error("No file_url found in API response");
  }

  // Step 2: Second call – download the file as blob
  const downloadResponse = await Axios.get(fileUrl, {
    responseType: "blob",
  });

  // Step 3: Get filename from file_url
  const filename = fileUrl.split("/").pop() || "Quotation.xlsx";

  return {
    blob: downloadResponse.data,
    filename,
  };
};



//Exports csv file
export const exportTrashQuotationCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null) return;

        if (filterField === "quotation_date") {
          params.append(`${filterField}_from`, filterValue.from_date);
          params.append(`${filterField}_to`, filterValue.to_date);
        }
        else if (filterField === "validity") {
          params.append(`${filterField}_from`, filterValue.from_date);
          params.append(`${filterField}_to`, filterValue.to_date);
        } else

          // If filterValue is an object (like from_date/to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            if (filterValue.from_date)
              params.append(`${filterField}_date_from`, filterValue.from_date);
            if (filterValue.to_date)
              params.append(`${filterField}_date_to`, filterValue.to_date);
            // if (filterValue.quotation_to_date)
            //   params.append(`${filterField}_from`, filterValue.from_date);
            // if (filterValue.quotation_to_date)
            //   params.append(`${filterField}_to`, filterValue.to_date);


          } else {
            // Primitive value
            params.append(filterField, String(filterValue));
          }
      }
    );
  }

  // Step 1: First call – get the file_url
  const response = await Axios.get(`/api/quotation/trash/export-to-excel/?${params.toString()}`);

  const fileUrl = response.data?.file_url;
  if (!fileUrl) {
    throw new Error("No file_url found in API response");
  }

  // Step 2: Second call – download the file as blob
  const downloadResponse = await Axios.get(fileUrl, {
    responseType: "blob",
  });

  // Step 3: Get filename from file_url
  const filename = fileUrl.split("/").pop() || "TrashQuotation.xlsx";

  return {
    blob: downloadResponse.data,
    filename,
  };
};

